<template>
    <div v-if="isModalOpen" @click.self="$emit('close')"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4 sm:p-0">
        <div
            class="bg-primary-bg dark:bg-primary-dark-bg p-6 sm:p-10 rounded-lg border border-light-border dark:border-dark-border w-full max-w-md sm:max-w-2xl max-h-[90vh] overflow-y-auto custom-scroll relative">

            <button @click="$emit('close')"
                class="absolute top-2 right-2 p-1 text-gray-400 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white">
                <XMarkIcon class="w-6 h-6" />
            </button>

            <form @submit.prevent="handleSubmit">
                <div class="mb-4" v-for="(label, key) in fields" :key="key">
                    <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">{{ label
                    }}</label>
                    <input v-model="form[key]" :type="key === 'driver_dt' ? 'date' : 'text'"
                        :maxlength="key === 'driver_tcno' ? 11 : key === 'driver_telno' ? 11 : key === 'driver_licenceno' ? 15 : undefined"
                        :pattern="key === 'driver_tcno' ? '[0-9]*' : undefined"
                        class="w-full border rounded px-3 py-2 text-sm bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required />
                </div>

                <div class="mb-6">
                    <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Sürücü
                        Durumu</label>
                    <select v-model="form.driver_status"
                        class="w-full p-2 border rounded mb-4 bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100 border-gray-300 dark:border-gray-600">
                        <option :value="1">Aktif</option>
                        <option :value="0">Pasif</option>
                    </select>
                </div>

                <div class="flex justify-end gap-3">
                    <button type="submit"
                        class="w-full bg-primary-button text-white py-2 px-4 rounded hover:bg-primary-button-hover transition">
                        {{ loading ? 'Kaydediliyor...' : (modalMode === 'create' ? 'Kaydet' : 'Güncelle') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { XMarkIcon } from '@heroicons/vue/24/outline';

export default {
    name: 'DriverModal',
    components: { XMarkIcon },
    props: {
        isModalOpen: Boolean,
        modalMode: {
            type: String,
            default: 'create'
        },
        driver: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            form: {
                driver_id: null,
                driver_name: '',
                driver_tcno: '',
                driver_dt: '',
                driver_telno: '',
                driver_province: '',
                driver_licenceno: '',
                driver_status: 1
            },
            fields: {
                driver_name: 'Ad Soyad',
                driver_tcno: 'TC Kimlik No',
                driver_dt: 'Doğum Tarihi',
                driver_telno: 'Telefon',
                driver_province: 'İl',
                driver_licenceno: 'Ehliyet No'
            }
        };
    },
    watch: {
        driver: {
            immediate: true,
            handler(newVal) {
                if (this.modalMode === 'edit' && newVal) {
                    this.form = {
                        driver_id: newVal.driver_id ?? null,
                        driver_name: newVal.driver_name ?? '',
                        driver_tcno: newVal.driver_tcno ?? '',
                        driver_dt: newVal.driver_dt ?? '',
                        driver_telno: newVal.driver_telno ?? '',
                        driver_province: newVal.driver_province ?? '',
                        driver_licenceno: newVal.driver_licenceno ?? '',
                        driver_status: newVal.driver_status ?? 1
                    };
                } else if (this.modalMode === 'create') {
                    this.resetForm();
                }
            }
        }
    },

    methods: {
        validateForm() {
            if (this.localDriver.driver_tcno.length !== 11 || !/^\d+$/.test(this.localDriver.driver_tcno)) {
                this.$toast.error('TC Kimlik No 11 haneli olmalıdır!');
                return false;
            }

            // if (!/^[A-Z0-9]{1,15}$/.test(this.localDriver.driver_licenceno)) {
            //     this.$toast.error('Geçerli bir ehliyet numarası giriniz!');
            //     return false;
            // }

            if (!/^[0-9]{10,11}$/.test(this.localDriver.driver_telno.replace(/\D/g, ''))) {
                this.$toast.error('Geçerli bir telefon numarası giriniz!');
                return false;
            }

            const birthDate = new Date(this.localDriver.driver_dt);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            if (age < 18) {
                this.$toast.error('Sürücü 18 yaşından büyük olmalıdır!');
                return false;
            }

            return true;
        },

        async handleSubmit() {
            if (this.loading) return;

            this.loading = true;
            try {
                const payload = {
                    ...this.form,
                    driver_id: this.driver?.driver_id ?? this.form.driver_id
                };
                payload.driver_status = parseInt(payload.driver_status);

                this.$emit('submit-driver', payload);
                this.$emit('close');

                if (this.modalMode === 'create') this.resetForm();
            } finally {
                this.loading = false;
            }
        },

        resetForm() {
            this.form = {
                driver_id: null,
                driver_name: '',
                driver_tcno: '',
                driver_dt: '',
                driver_telno: '',
                driver_province: '',
                driver_licenceno: '',
                driver_status: 1
            };
        }
    }
};
</script>